import React from "react";
import ClassCard from "../../../components/Common/ClassCard/ClassCard";
import SeriesCard from "../../../components/Common/SeriesCard/SeriesCard";

const ShotClassContainer = ({
  type,
  data,
  handleDelete,
  isDeleteVisible,
  isCheckboxVisible,
  isChecked,
  isInfoIconVisible,
  handleCheckboxChange,
  infoText,
  isCopyIconVisible,
  imageClick,
  isHistoryIconVisible,
  handleHistroyClick,
  handleCopyClick,
}) => {
  const shortclassType = ["class", "series", "collection"];
  return (
    <>
      {type === shortclassType[0] && (
        <ClassCard
          handleDelete={() => handleDelete(data?.ID, data?.Name)}
          isCheckboxVisible={isCheckboxVisible}
          isChecked={isChecked}
          handleCheckboxChange={(e) => handleCheckboxChange(e, data)}
          isInfoIconVisible={isInfoIconVisible}
          infoText={infoText}
          shotClassData={data}
        />
      )}
      {(type === shortclassType[1] || type === shortclassType[2]) && (
        <SeriesCard
          seriesData={data}
          handleDelete={handleDelete}
          isDeleteVisible={isDeleteVisible}
          imageClick={imageClick}
          isCheckboxVisible={isCheckboxVisible}
          isChecked={isChecked}
          handleCheckboxChange={(e) => handleCheckboxChange(e, data)}
          isInfoIconVisible={isInfoIconVisible}
          infoText={infoText}
          isCopyIconVisible={isCopyIconVisible}
          isHistoryIconVisible={isHistoryIconVisible}
          handleHistroyClick={handleHistroyClick}
          handleCopyClick={handleCopyClick}
        />
      )}
    </>
  );
};

export default ShotClassContainer;
